import { render, staticRenderFns } from "./aiPresetsList.vue?vue&type=template&id=2eed86d0&scoped=true&"
import script from "./aiPresetsList.vue?vue&type=script&lang=js&"
export * from "./aiPresetsList.vue?vue&type=script&lang=js&"
import style0 from "./aiPresetsList.vue?vue&type=style&index=0&id=2eed86d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eed86d0",
  null
  
)

export default component.exports